export default "__VITE_ASSET__BWCzYqSQ__"